"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const ModuleErrorFetch_1 = __importDefault(require("@becrop/components/Modules/Common/Models/ModuleErrorFetch"));
const ModelCompositorData_1 = __importDefault(require("../models/ModelCompositorData"));
class ServiceRateComposition {
    constructor(proposalId) {
        this.proposalId = proposalId;
        this.dataLoading = false;
        this.data = new ModelCompositorData_1.default({ proposalId: 0, rates: [] });
        this.errorFetchData = new ModuleErrorFetch_1.default({ messages: '', status: -1 });
        this.failedCall = false;
    }
    async call() {
        await this.fetchCompositionData();
    }
    async fetchCompositionData() {
        this.dataLoading = true;
        try {
            const request = await fetch(`/data/results/rate/compositor/${this.proposalId}`);
            const response = await request.json();
            console.log(response);
            if ('status' in response) {
                console.log('asdfasd');
                this.errorFetchData = new ModuleErrorFetch_1.default(response);
                this.failedCall = true;
                console.error(response);
            }
            else {
                this.data = new ModelCompositorData_1.default(response);
            }
        }
        catch (error) {
            this.data = new ModelCompositorData_1.default(this.fakeData);
        }
        this.dataLoading = false;
    }
    get isFailedCall() {
        return this.failedCall;
    }
    get getErrorFetchData() {
        return new ModuleErrorFetch_1.default(this.errorFetchData);
    }
    get collectData() {
        return this.data;
    }
    get isLoading() {
        return this.dataLoading;
    }
    get fakeData() {
        return new ModelCompositorData_1.default({
            proposalId: -1,
            rates: new Array(),
        });
    }
}
exports.default = ServiceRateComposition;
